/**
 * Qualitative Benefit Type Enum
 *
 * Defines types of non-quantified (qualitative) benefits representing strategic value.
 */
export const QualitativeBenefitTypeLabel = {
    market_parity: 'Market Parity',
    client_retention: 'Client Retention',
    customer_satisfaction: 'Customer Satisfaction',
    employee_satisfaction: 'Employee Satisfaction',
    sales_support: 'Sales Support',
    marketing_support: 'Marketing Support',
    operational_efficiency: 'Operational Efficiency',
    competitive_advantage: 'Competitive Advantage',
    brand_value: 'Brand Value',
    other: 'Other',
};
export const QualitativeBenefitTypeDescription = {
    market_parity: 'Brings capabilities in line with market expectations',
    client_retention: 'Helps retain existing clients',
    customer_satisfaction: 'Improves customer satisfaction and experience',
    employee_satisfaction: 'Improves employee morale and satisfaction',
    sales_support: 'Supports sales team effectiveness',
    marketing_support: 'Supports marketing initiatives',
    operational_efficiency: 'Makes operations more efficient',
    competitive_advantage: 'Provides competitive differentiation',
    brand_value: 'Enhances brand perception and value',
    other: 'Other qualitative benefits',
};
export const QUALITATIVE_BENEFIT_TYPES = [
    'market_parity',
    'client_retention',
    'customer_satisfaction',
    'employee_satisfaction',
    'sales_support',
    'marketing_support',
    'operational_efficiency',
    'competitive_advantage',
    'brand_value',
    'other',
];
//# sourceMappingURL=qualitative-benefit-type.enum.js.map